import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const AdminList = () => {
  const { data: adminUsers, isLoading } = useQuery({
    queryKey: ['admin-users'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('is_admin', true);
      
      if (error) throw error;
      return data;
    }
  });

  if (isLoading) {
    return <div className="min-h-screen bg-gradient-to-br from-black via-[#1A1F2C] to-black/90 pt-40 p-4">Loading admin users...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#1A1F2C] to-black/90 pt-40 p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Users</h1>
      <div className="space-y-4">
        {adminUsers?.map((user) => (
          <div key={user.id} className="flex items-center gap-4 p-4 bg-secondary/20 rounded-lg">
            <Avatar>
              <AvatarImage src={user.profile_image_url} />
              <AvatarFallback>{user.name?.charAt(0) || 'U'}</AvatarFallback>
            </Avatar>
            <div>
              <h2 className="font-semibold">{user.name || 'Anonymous'}</h2>
              <p className="text-sm text-gray-400">@{user.username}</p>
            </div>
          </div>
        ))}
        {adminUsers?.length === 0 && (
          <p className="text-gray-400">No admin users found.</p>
        )}
      </div>
    </div>
  );
};

export default AdminList;